var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualityagentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6652_326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6652_326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7992 46.7695H11.1992V56.3695H20.7992V46.7695Z",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7992 37.1719H27.1992V56.3719H36.7992V37.1719Z",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7992 35.5703V27.5703H43.1992V56.3703H52.7992V41.9703",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7992 17.9711V8.37109H43.1992",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7992 8.37109L31.9992 27.5711H20.7992L11.1992 37.1711",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6652_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.371094)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6652_326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.371094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityagentIcon);
export default __webpack_public_path__ + "static/media/QualityagentIcon.8c19c0b2358b759fab627f38e84c94e9.svg";
export { ForwardRef as ReactComponent };